import styled, { css } from "styled-components";

interface SContainerProps {
	$padding0?: boolean;
}

export const SContainer = styled.div<SContainerProps>`
	display: flex;
	justify-content: center;

	${(props) =>
		!props.$padding0 &&
		css`
			padding-block: 47px 40px;
		`}
`;
